import isNil from 'lodash/isNil';

/**
 * Internal feature flags stored in `localStorage`. Set them in DevTools, e.g.
 * `localStorage.setItem('PROVIDERS_SHOW_SIMPLE_EXPORT_BUTTON', 'true')`.
 */
export const PROVIDERS_SHOW_EXPORT_BUTTON = 'PROVIDERS_SHOW_EXPORT_BUTTON';
export const PROVIDERS_SHOW_SIMPLE_EXPORT_BUTTON = 'PROVIDERS_SHOW_SIMPLE_EXPORT_BUTTON';

/** Keys that must survive login/logout `localStorage.clear()`. */
const PRESERVED_KEYS = [PROVIDERS_SHOW_EXPORT_BUTTON, PROVIDERS_SHOW_SIMPLE_EXPORT_BUTTON];

/**
 * @param {string} key
 * @returns {boolean}
 */
export const isLocalStorageFlagEnabled = (key) => {
    const value = (window.localStorage.getItem(key) ?? '').toString().trim().toLowerCase();
    return value === 'true' || value === '1';
};

/**
 * Clears `localStorage` but restores the internal feature flags so they do not
 * have to be re-set after every login.
 * @returns {void}
 */
export const clearLocalStoragePreservingFlags = () => {
    const preserved = PRESERVED_KEYS.reduce((acc, key) => {
        const value = window.localStorage.getItem(key);
        if (!isNil(value)) acc[key] = value;

        return acc;
    }, /** @type {Record<string, string>} */ ({}));

    window.localStorage.clear();

    for (const [key, value] of Object.entries(preserved)) window.localStorage.setItem(key, value);
};
